export default function initHeader() {
    const header = document.querySelector(".header");
    if (!header)
        return;
    const menu = header.querySelector(".header__menu");
    const menuTrigger = header.querySelector(".header__mobile-trigger");
    let isActive = false;
    menuTrigger === null || menuTrigger === void 0 ? void 0 : menuTrigger.addEventListener("click", () => {
        isActive = !isActive;
        menu === null || menu === void 0 ? void 0 : menu.classList.toggle("is-active", isActive);
        menuTrigger === null || menuTrigger === void 0 ? void 0 : menuTrigger.classList.toggle("is-active", isActive);
    });
    window.addBeforeNavigate(() => {
        menu === null || menu === void 0 ? void 0 : menu.classList.toggle("is-active", false);
        menuTrigger === null || menuTrigger === void 0 ? void 0 : menuTrigger.classList.toggle("is-active", false);
    }, "close-mobile-menu");
}
